import DashboardCardOptionItem from '@/components/ReportDashboard/Shared/DashboardCardOptionItem'
import { useDashboardCardOptions } from '@/components/ReportDashboard/Shared/useDashboardCardOptions'
import { RADashboardCardId } from '@/constants/ReportDashboard/cards-enums'
import { FADashboardType } from '@/constants/ReportDashboard/dashboards/dashboard-types'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { RADashboardLayout } from '@/interfaces/raDashboard.interface'
import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogTitle, Divider, IconButton, List, Typography } from '@mui/material'
import React from 'react'

type DashboardAddCardModalProps = {
  open: boolean
  onClose: () => void
  layout: RADashboardLayout
  selectedTab: string
  setLayout: (newLayout: RADashboardLayout) => void
  dashboardType: FADashboardType
}

const DashboardAddCardModal: React.FC<DashboardAddCardModalProps> = ({
  open,
  onClose,
  layout,
  selectedTab,
  setLayout,
  dashboardType,
}) => {
  const theme = useTheme()
  const { uniqueCards, datapointCards, isCardInUse, addCard } = useDashboardCardOptions({
    layout,
    selectedTab,
    setLayout,
    dashboardType,
  })

  const handleAdd = (cardId: RADashboardCardId) => {
    addCard(cardId)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { backgroundColor: theme.cardBackground, borderRadius: '8px' } }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          color: theme.textPrimary,
        }}
      >
        Add Card
        <IconButton onClick={onClose} size="small" sx={{ color: theme.textSecondary }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ borderColor: theme.border }} />
      <List sx={{ maxHeight: '60vh', overflowY: 'auto', px: 2, pt: 1, pb: 2 }}>
        {uniqueCards.map((cardId) => (
          <DashboardCardOptionItem
            key={cardId}
            cardId={cardId}
            inUse={isCardInUse(cardId)}
            disabled={isCardInUse(cardId)}
            tooltipPlacement="right"
            onClick={() => handleAdd(cardId)}
          />
        ))}

        <Typography variant="subtitle2" sx={{ py: 1.5, fontWeight: 400, color: theme.textPrimary }}>
          Single Datapoints
        </Typography>

        {datapointCards.map((cardId) => (
          <DashboardCardOptionItem
            key={cardId}
            cardId={cardId}
            inUse={isCardInUse(cardId)}
            disabled={isCardInUse(cardId)}
            tooltipPlacement="right"
            onClick={() => handleAdd(cardId)}
          />
        ))}
      </List>
    </Dialog>
  )
}

export default DashboardAddCardModal
